export default __webpack_public_path__ + "static/healthcare-fraud-prevention-img-1-4f998a1b713325b76e29cedca09a81f6.svg";